import { render, staticRenderFns } from "./RecommendedProductsContainer.vue?vue&type=template&id=efad021c&scoped=true&"
import script from "./RecommendedProductsContainer.vue?vue&type=script&lang=js&"
export * from "./RecommendedProductsContainer.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedProductsContainer.vue?vue&type=style&index=0&id=efad021c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efad021c",
  null
  
)

export default component.exports